<template>
    <div>

        <arhslgl-base-header-sec title="Архива службеног гласника" slug="sgarh"></arhslgl-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Врста документа</label>
                                <div class="d-flex pt-2 mb-3">
                                    <div class="custom-control custom-radio mr-3">
                                        <input type="radio" v-model="documentType" class="custom-control-input" value="laws"
                                            id="customRadioInline1">
                                        <label class="custom-control-label" for="customRadioInline1"
                                            value="laws">прописи</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" v-model="documentType" class="custom-control-input" value="ads"
                                            id="customRadioInline2">
                                        <label class="custom-control-label" for="customRadioInline2"
                                            value="ads">огласи</label>
                                    </div>
                                </div>
                                <!-- <select class="form-control full-width" multiple="" size="4" v-model="docTypeIds">
                                    <option label="Сви" value="-1" selected="selected">Сви</option>
                                    <option v-for="item in docTypes" :label="item.l" :value="item.k"
                                            v-bind:key="item.k">{{item.l}}
                                    </option>
                                </select> -->
                                <div class="sgarh">
                                    <multiselect v-model="docTypeIds" :options="docTypes" :multiple="true" placeholder="Сви"
                                        track-by="k" label="l" :show-labels="false"></multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm ">
                                <label class="form-label">Доносилац</label>
                                <select class="form-control mb-2 full-width" v-model="authorityType"
                                    :disabled="documentType !== 'laws'">
                                    <option value="all">Сви</option>
                                    <option value="active">Актуелни</option>
                                    <option value="inactive">Неактуелни</option>
                                </select>
                                <select id="br_god" multiple="" class="form-control full-width" size="4"
                                    v-model="authorityIds" :disabled="documentType !== 'laws'">
                                    <option v-for="item in authorities" v-bind:key="item.k" :label="item.l" :value="item.k"
                                        selected="selected">{{ item.l }}
                                    </option>
                                </select>
                                <!-- <multiselect 
                                    v-model="authorityIds"
                                    :disabled="documentType !== 'laws'"
                                    :options="authorities"
                                    :multiple="true"
                                    placeholder="Сви"
                                    track-by="k"
                                    label="l"  
                                    :show-labels="false"  
                                ></multiselect> -->

                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm mb-2 mb-md-4">
                                <label for="number" class="form-label">Број гласила</label>
                                <input type="text" v-model="number" id="number" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <div class="d-lg-flex align-items-center">
                                    <div class="year-inline-group d-flex align-items-center mr-lg-4">
                                        <label class="form-label " for="yearFrom">Година од</label>
                                        <select class="form-control" v-model="yearFrom">
                                            <option v-for="item in filters.years" v-bind:key="item.k" :label="item.l"
                                                :value="item.k">{{ item.l }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="year-inline-group d-flex align-items-center">
                                        <label class="form-label " for="yearTo">до</label>
                                        <select class="form-control" v-model="yearTo">
                                            <option v-for="item in filters.years" v-bind:key="item.k" :label="item.l"
                                                :value="item.k">{{ item.l }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm row">

                    </div>
                    <div class="form-group form-group-sm">
                        <label for="title_query" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="title_query" v-model="title_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="title_query_all" v-model="title_query_all">
                                    <label class="in-btn-form-label" for="title_query_all">Све ове речи</label>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="text_query" class="form-label">Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="text_query" v-model="text_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="text_query_all" v-model="text_query_all">
                                    <label class="in-btn-form-label" for="text_query_all">Све ове речи</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm  ">
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>

            </div>

            <result-counter v-if="searchResult !== null" :count="searchResult.resultSize"
                :limit="searchResult.limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields" responsive="sm">


                    <template v-slot:cell(name)="data">
                        <!--          api/slglrs/pdf?id=4349              -->
                        <!--             /SlGlasnikPortal/slglrs/viewAct/332515           -->
                        <router-link target="_blank" v-if="data.item.url"
                            :to="{ path: '/slglrs/viewAct/' + data.item.id }">{{
                                data.item.name
                            }}</router-link>
                        <router-link v-else :to="'slglrsViewPdf/' + data.item.ogId" class="color-link" target="_blank">
                            {{ data.item.name }} </router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>

            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import ArhslglBaseHeaderSec from '@/base_pages/arhslgl/ArhslglBaseHeaderSec.vue';
// import {SortedTable, SortLink} from "vue-sorted-table";
import ResultCounter from '@/partials/ResultCounter.vue';

import { mapState } from 'vuex';

export default {
    name: "ArhslglSgarhSearchPage",
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
            authorityType: null,
            documentType: null,
            docTypes: [],
            authorities: [],

            number: '',
            title_query: '',
            text_query: '',
            title_query_all: true,
            text_query_all: true,
            authorityIds: [],
            docTypeIds: [],
            yearFrom: null,
            yearTo: null,
            resultLimit: 50,

            filters: {
                docTypesLaws: [],
                docTypesAds: [],
                activeAuthorities: [],
                inactiveAuthorities: [],
                years: []
            },

            searchResult: null,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

            fields: [
                { label: 'Назив', key: 'name', sortable: true },
                { label: 'Број', key: 'number', sortable: true },
                { label: 'Доносилац', key: 'authority', sortable: true },
                { label: 'Врста документа', key: 'docType', sortable: true },
                { label: 'Датум', key: 'timestamp', sortable: true }
            ],

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        ArhslglBaseHeaderSec,
        ResultCounter
    },
    computed: {
        ...mapState(['userInfoState']),

        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SGARHSTARO')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        openAct(actId) {
            axios.get(this.baseApiUrl + 'api/RegistarServlet/act-' + actId).then(response => {
                this.actHTML = response.data
            });
            this.isActOpen = true;
        },
        fetchData() {
            axios.get(this.baseSLGLApiUrl + 'prins/archive/search/SGARHSTARO/filter')
                .then(response => {
                    this.filters = response.data;
                    this.reset();
                });
        },
        search() {
            let dids = [];
            this.docTypeIds.filter(obj => {
                dids.push(obj.k);
            });

            var url = this.baseDIApiUrl + 'SGARHSTARO/search';
            var data = {
                bk: this.text_query === '' ? null : this.text_query,
                tk: this.title_query === '' ? null : this.title_query,
                bmo: this.text_query_all,
                tmo: this.title_query_all,
                limit: this.resultLimit,
                yf: this.yearFrom,
                yt: this.yearTo,
                n: this.number === '' ? null : this.number,
                aids: this.authorityIds,
                dids: dids,
                il: this.documentType === 'laws',
            };
            const vm = this;
            axios.post(url, data).then(response => {
                this.searchResult = response.data;

                var data = response.data.result;

                for (var i = 0; i < data.length; i++) {
                    data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                }

                this.result = data;
                this.resultSize = response.data.resultSize;
            }).catch(function (error) {
                if (error.response.status === 401) {
                    // nije ulogovan
                    // otvori modal za logovanje
                    vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                }
                console.log(error);
            });

        },
        reset() {
            this.documentType = 'laws';

            if (this.authorityType === 'all') {
                this.authorityIds = [];
                for (var i = 0; i < this.authorities.length; i++) {
                    this.authorityIds.push(this.authorities[i].k);
                }
            } else this.authorityType = 'all';

            this.number = '';
            this.docTypeIds = [];
            this.yearTo = this.filters.years[0].k;
            this.yearFrom = this.filters.years[this.filters.years.length - 1].k;
            if (this.$route.query.q) {
                this.title_query = this.$route.query.q;
            } else {
                this.title_query = '';
            }

            this.text_query = '';
            this.title_query_all = true;
            this.text_query_all = true;

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;
            this.searchResult = null;
        }
    },
    watch: {
        // $route.query.q
        $route(to, from) {
            console.log("to: ", to);
            console.log("from: ", from);
            console.log("$route.query.q: ", this.$route.query.q);
            // react to route changes...
        },
        documentType: function () {
            this.docTypeIds = [];
            if (this.documentType === 'laws') {
                this.docTypes = this.filters.docTypesLaws;
            } else this.docTypes = this.filters.docTypesAds;
        },
        authorityType: function () {
            if (this.authorityType === 'all') {
                this.authorities = this.filters.activeAuthorities.concat(this.filters.inactiveAuthorities);
            } else if (this.authorityType === 'active') {
                this.authorities = this.filters.activeAuthorities;
            } else this.authorities = this.filters.inactiveAuthorities;

            for (var i = 0; i < this.authorities.length; i++) {
                this.authorityIds.push(this.authorities[i].k);
            }
        },
        // resultLimit: function () {
        //     this.resultSize = null;
        // }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        if (this.$route.query.q) {
            this.title_query = this.$route.query.q;
            this.search();
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_arhslgl';
    }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table-bootstrap-vue thead tr th:first-child {
    width: 50%;
}

.sgarh .multiselect__tag {
    background: #3d7ab9 !important;
    margin-top: 4px;
}

.sgarh .multiselect__placeholder {
    color: black !important;
    font-size: 0.9rem;
}

.sgarh .multiselect__select:before {
    border-color: black transparent transparent !important;
    border-width: 6px 3px 0 !important;
    opacity: 0.8;
}

/* .multiselect__tags {
        border-radius: unset!important;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.22);
        padding: 4px 40px 0 12px!important;
        border: 1px solid #ced4da;  
    } */
.multiselect {
    min-height: 35px;
}

.multiselect__select {
    top: 4px !important;
    right: -9px !important;
}

#__BVID__116 {
    margin-top: -2px;
}

.sgarh .multiselect__option--highlight {
    background: #409edc !important;
}

.sgarh .multiselect__option--highlight {
    background: #3d7ab9 !important;
}

.sgarh .multiselect__tag-icon {
    background: #3d7ab9 !important;
}

.sgarh .multiselect__tag-icon:hover {
    background: #5288be !important;
}

.sgarh .multiselect__option--highlight {
    background: #3d7ab9 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>